/**
 * SA-1091: the mailbox list for the Inbox's chip row, under its OWN key —
 * never `MAILBOXES_KEY`, whose query refetches every ten seconds while a
 * backload runs (the admin page's cadence). It runs on the app's one query
 * client so the Inbox page, which mounts no provider of its own in its
 * tests, can read it; a failed read is no chips, never an error line.
 */
import { useQuery } from '@tanstack/react-query'
import { mailboxesService, type Mailbox } from '@/services/mailboxes'
import { queryClient } from '@/services/queryClient'

export const INBOX_FILTER_CHIPS_KEY = ['inbox', 'filter-chips'] as const

/** SA-1092: the shape rule needs to know when the list has been READ, a
 * failed read included (then there are no chips and no desk). */
export function useInboxFilterChipsState(enabled: boolean): { mailboxes: Mailbox[] | undefined; loaded: boolean } {
  const { data, isError } = useQuery(
    {
      queryKey: INBOX_FILTER_CHIPS_KEY,
      queryFn: mailboxesService.list,
      enabled,
      staleTime: 5 * 60_000,
      retry: false,
    },
    queryClient,
  )
  return { mailboxes: data, loaded: !enabled || data !== undefined || isError }
}

export function useInboxFilterChips(enabled: boolean): Mailbox[] | undefined {
  const { data } = useQuery(
    {
      queryKey: INBOX_FILTER_CHIPS_KEY,
      queryFn: mailboxesService.list,
      enabled,
      staleTime: 5 * 60_000,
      retry: false,
    },
    queryClient,
  )
  return data
}
